import { z } from 'zod'

export const schema = z.object({
  table_name: z.string(),
  value_date: z.iso.date(),
})

export type SchemaType = z.infer<typeof schema>
